import { createFileRoute, getRouteApi } from '@tanstack/react-router'

import { LearnpathsSummaryDetailsTabPanel } from '@/learnpaths-summary/components/LearnpathsSummaryDetailsTabPanel/LearnpathsSummaryDetailsTabPanel'
import LearnpathsSummaryDetailsTabsReleases from '@/learnpaths-summary/components/LearnpathsSummaryDetailsTabsReleases/LearnpathsSummaryDetailsTabsReleases'
import { useManagedLearnpath } from '@/learnpaths/queries/useManagedLearnpath'

const { useParams, useSearch } = getRouteApi(
  '/company/_management/learnpaths/overview/$learnpathId',
)

export const Route = createFileRoute(
  '/company/_management/learnpaths/overview/$learnpathId/releases',
)({
  component: ReleasesTab,
})

function ReleasesTab() {
  const { learnpathId } = useParams()
  const { only_direct_learners_stats = true } = useSearch()
  const { data } = useManagedLearnpath({
    learnpathId,
    only_direct_learners_stats,
  })

  return (
    <LearnpathsSummaryDetailsTabPanel>
      <LearnpathsSummaryDetailsTabsReleases
        recurringDraftId={data?.recurring_draft_id}
        isLPactive={data?.active}
        hasBeenActive={data?.has_been_active}
        releases={data?.releases}
      />
    </LearnpathsSummaryDetailsTabPanel>
  )
}
